import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { CardFooter, Col, Row } from "reactstrap";
import Loader from "react-loaders";
import Records from "./table";
import { useTravelCostList } from "Api/Coordinator/TravelCost";


const Default = () => {
    const [selectedCommunity, setSelectedCommunity] = useState(0);

    const { data, error, isLoading } = useTravelCostList(selectedCommunity);
    const travelList = data?.data?.travelcostList || [];
    const totalCount=data?.data?.totalCount;


    const handleCommunityChange = (event) => {
        setSelectedCommunity(event.target.value);
    };

    return (
        <Fragment>
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="10" lg="10">
                            <PageHeading />
                        </Col>
                    </Row>

                    {isLoading ? (
                        <Loader
                            type="ball-grid-pulse"
                            className={"mt-3 d-flex mx-auto justify-content-center"}
                        />
                    ) : (
                        <Row>
                            <Col md="12" lg="12">
                                <Records data={travelList} totalCount={totalCount} />
                            </Col>
                        </Row>
                    )}
                </div>
            </TransitionOnLoad>

            {!isLoading && data && (
                <div className="chat-layout-footer verzoken-footer-height">
                    <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                        <div className="d-flex gap-3 col-1">
                            <select
                                className="form-select"
                                value={selectedCommunity}
                                onChange={handleCommunityChange}
                            >
                                <option value={0}>Alle Organisaties</option>

                                {data?.data.communityList?.map((community, index) => (
                                    <option
                                        key={index}
                                        value={community.iCommunityId}
                                    >
                                        {community.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </CardFooter>
                </div>
            )}
        </Fragment>
    );
};

export default Default;